<template>
  <div>
    <div class="bulletin-search-div">
      <div class="bulletin-search-row-div bulletin-search-bottom-border">
        <div class="bulletin-search-left-region-div">
            <span class="bulletin-search-label-span">标的所在地：</span>
            <span :class="!searchParam.region?'selected':'un-selected'" class="bulletin-search-item-all" @click="changeSearchParam(null, 1)">全部</span>
        </div>
            <div class="bulletin-search-region-div">
              <div class="bulletin-search-region-div">
                <span :class="searchParam.region==t.id?'selected':'un-selected'" class="bulletin-serach-region-item"
                v-for="t in firstRegions" :key="t.id" @click="changeSearchParam(t.id, 1)">{{t.title}}</span>
            </div>      
            <div class="bulletin-search-region-div">
                <span :class="searchParam.region==t.id?'selected':'un-selected'" class="bulletin-serach-region-item"
                v-for="t in lastRegions" :key="t.id" @click="changeSearchParam(t.id, 1)">{{t.title}}</span>
            </div>  
        </div>
      </div>
      <div class="bulletin-search-row-div bulletin-search-bottom-border bulletin-search-bottom-un-border">
        <span class="bulletin-search-label-span">标的类型：</span>
        <span :class="!searchParam.type?'selected':'un-selected'" class="bulletin-search-item-all" @click="changeSearchParam(null, 2)">全部</span>
        <span :class="searchParam.type==t.dictKey?'selected':'un-selected'" class="bulletin-serach-type-item" 
            v-for="t in bulletinTypeDict" :key="t.id" @click="changeSearchParam(t.dictKey, 2)">{{t.dictValue}}</span>
      </div>
      <div class="bulletin-search-row-div bulletin-search-bottom-un-border">
        <span class="bulletin-search-label-span">标的状态：</span>
        <span :class="!searchParam.auctionStatus?'selected':'un-selected'" class="bulletin-search-item-all" @click="changeSearchParam(null, 3)">全部</span>
        <span :class="searchParam.auctionStatus==0?'selected':'un-selected'" class="bulletin-serach-type-item" @click="changeSearchParam(0, 3)">未开始</span>
        <span :class="searchParam.auctionStatus==10?'selected':'un-selected'" class="bulletin-serach-type-item" @click="changeSearchParam(10, 3)">报名中</span>
        <span :class="searchParam.auctionStatus==11?'selected':'un-selected'" class="bulletin-serach-type-item" @click="changeSearchParam(11, 3)">拍卖中</span>
        <span :class="searchParam.auctionStatus==12?'selected':'un-selected'" class="bulletin-serach-type-item" @click="changeSearchParam(12, 3)">竞价中</span>
        <span :class="searchParam.auctionStatus==2?'selected':'un-selected'" class="bulletin-serach-type-item" @click="changeSearchParam(2, 3)">竞价暂停</span>
        <span :class="searchParam.auctionStatus==13?'selected':'un-selected'" class="bulletin-serach-type-item" @click="changeSearchParam(13, 3)">竞价截止</span>
        <span :class="searchParam.auctionStatus==3?'selected':'un-selected'" class="bulletin-serach-type-item" @click="changeSearchParam(3, 3)">已成交</span>
        <!-- <span :class="searchParam.auctionStatus==-1?'selected':'un-selected'" class="bulletin-serach-type-item" @click="changeSearchParam(-1, 3)">已流拍</span> -->
        <span class="bulletin-search-input-span">
          <input class="search-title-input" v-model="searchParam.searchText" placeholder="请输入搜索关键字"/>
          <span class="search-title-button" @click="onLoad(page)">搜索</span>
        </span>
      </div>
    </div>
    <div class="bulletin-table-container">
      <div style="height: 30px;"></div>
      <table class="bulletin-table">
        <thead>
          <tr>
            <th class="col-name">标的名称</th>
            <th class="col-time">剩余时间</th>
            <th class="col-base-price">标的底价</th>
            <th class="col-current-price">当前价</th>
            <th class="col-status">状态</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="b in bulletinData" :key="b.id" @click="toLotDetail(b)"  class="bulletin-table-row">
            <td class="col-name">
              <div class="name-text" :title="b.title">{{b.lotName}}</div>
            </td>
            <td class="col-time">
              <!-- <span v-if="getStartOfDistance(b.auctionTime)>0" class="time-countdown">{{getStartOfDistance(b.auctionTime)}}天{{getRemainingTime(b.auctionTime)}}</span>
              <span v-else class="time-ended">--</span> -->
              <span class="time-countdown" v-if="b.auctionStatus ==1 || b.auctionStatus == 2">{{ formatCountdown(countdownValues[b.id] || b.timeRemaining) }}</span>
              <span class="time-countdown" v-else>{{b.timeRemainingStr}}</span>
            </td>
            <td class="col-base-price">
              <span class="price-value">¥{{parseFloat(b.startPrice || 0).toFixed(2)}}</span>
            </td>
            <td class="col-current-price">
              <span v-if="b.currentQuoted" class="price-value highlight">¥{{parseFloat(b.currentQuoted).toFixed(2)}}</span>
              <span v-else class="price-value">--</span>
            </td>
            <td class="col-status">
              <span :class="getStatusClass(b.auctionHallLotStatus, b.backOutStatus)" class="status-tag">
                {{getAuctionStatusText(b.auctionHallLotStatus, b.backOutStatus)}}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="bulletin-page-class">
        <div class="el-page-class">
          <el-pagination   @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page.currentPage"
          :page-sizes="[10, 20, 30, 50]" :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
          </el-pagination>
        </div>
      </div>
    </div>
    <div style="height: 20px;"></div>
  </div>
</template>

<script>
import {getBizDictByCode} from '@/api/system/dict'
import {getLazyTree} from "@/api/base/region";


import { cmsLotList } from '@/api/biz/auction/auctionLot';
export default {
  name: 'BulletinListView',
  data() {
    return {
      topCode: '00',
      bulletinData: [],
      bulletinTypeDict: [],
      meetingLoading: false,
      regionDict: [],
      firstRegions: [],
      lastRegions: [],
      searchParam: {
        searchText: null,
        region: null,
        type: null,
        auctionStatus: null,
        bulletinType: 1,
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      countdownTimers: {}, // 存储每个标的的倒计时定时器
      countdownValues: {} // 存储每个标的的倒计时值
    }
  },
  created(){
    this.getDict();
    this.searchParam.type = this.$route.query.type
    this.searchParam.region = this.$route.query.region
    this.onLoad(this.page);
  },
  methods: {
    
    toLotDetail(lot){
      this.$router.push({path: "/lotDetail", query: {lotId: lot.id}})
    },
    startCountdowns() {
      // 清理现有的定时器
      this.clearAllTimers();
      
      // 重置 countdownValues
      this.countdownValues = {};
      
      // 为每个标的启动倒计时（仅 auctionStatus == 1 的状态）
      this.bulletinData.forEach(item => {
        if (item.auctionStatus == 1 && item.timeRemaining && item.timeRemaining > 0) {
          // 使用 $set 确保响应式
          this.$set(this.countdownValues, item.id, item.timeRemaining);
          console.log("startSingleCountdown init", item.id, item.timeRemaining);
          this.startSingleCountdown(item.id);
        } else {
          this.$set(this.countdownValues, item.id, item.timeRemaining || 0);
        }
      });
    },
    
    startSingleCountdown(lotId) {
      const item = this.bulletinData.find(b => b.id === lotId);
      if (!item || item.auctionStatus != 1 || this.countdownValues[lotId] <= 0) {
        return;
      }
      
      this.countdownTimers[lotId] = setInterval(() => {
        // console.log("startSingleCountdown", lotId, this.countdownValues[lotId])
        if (this.countdownValues[lotId] > 0) {
          // this.countdownValues[lotId]--;
          this.$set(this.countdownValues, lotId, this.countdownValues[lotId] - 1);
        } else {
          // 倒计时结束，清理定时器
          this.clearTimer(lotId);
        }
      }, 1000);
    },
    
    clearTimer(lotId) {
      if (this.countdownTimers[lotId]) {
        clearInterval(this.countdownTimers[lotId]);
        delete this.countdownTimers[lotId];
      }
    },
    
    clearAllTimers() {
      Object.keys(this.countdownTimers).forEach(lotId => {
        this.clearTimer(lotId);
      });
    },
    
    formatCountdown(timeSeconds) {
      if (timeSeconds <= 0) {
        return '--';
      }
      
      const days = Math.floor(timeSeconds / (24 * 60 * 60));
      const hours = Math.floor((timeSeconds % (24 * 60 * 60)) / (60 * 60));
      const minutes = Math.floor((timeSeconds % (60 * 60)) / 60);
      const seconds = timeSeconds % 60;
      // console.log('formatCountdown called with:', timeSeconds, 'result:', `${days}天${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`);
      let result = '';
      if (days > 0) {
        result += `${days}天`;
      }
      if (hours > 0 || days > 0) {
        result += `${hours.toString().padStart(2, '0')}:`;
      }
      result += `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
      
      return result;
    },
    announcementName(value) {
      if (value == 1) {
        return '拍卖公告'
      } else if (value == 2) {
        return '变更公告'
      } else if (value == 3)  {
        return '成交公告'
      }
    },
    jumpDetail(b,type){
      // this.$router.push({path:"/bulletinDetail", query: {bulletinId: b.id}})
      if (type==1) {
        this.$router.push({ path: "/bulletinDetail", query: { bulletinId: b.id, address: b.region } })
      } else {
        this.$router.push({ path: "/dealDetail", query: { bulletinType: b.bulletinType, bulletinId: b.id, address: b.region } })
      }
    },
    changeSearchParam(value, type){
      if(type==1 && value!=this.searchParam.region){        
        this.searchParam.region = value;    
      }else if(type==2 && value!=this.searchParam.type){        
        this.searchParam.type = value;  
      }else if(type==3 && value!=this.searchParam.auctionStatus){        
        this.searchParam.auctionStatus = value;       
      }else if(type==4 && value!=this.searchParam.bulletinType){        
        this.searchParam.bulletinType = value;       
      }else{
        return;
      }
      this.onLoad(this.page);
    },
    getStartOfDistance(date){
      return parseInt(((new Date(date).getTime()/(24*60*60*1000))-(new Date().getTime()/(24*60*60*1000))))
    },
    getRemainingTime(auctionTime) {
      const now = new Date().getTime();
      const auction = new Date(auctionTime).getTime();
      const diff = auction - now;
      
      if (diff <= 0) return '';
      
      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);
      
      let result = '';
      if (hours > 0) result += `${hours}小时`;
      if (minutes > 0) result += `${minutes}分`;
      if (seconds > 0) result += `${seconds}秒`;
      
      return result;
    },
    getAuctionStatusText(status, backOutStatus) {
      if (status == 0) return '未开始';
      if (status == 10) return '报名中';
      if (status == 11) return '拍卖中';
      if (status == 12) return '竞价中';
      if (status == 2) return '竞价暂停';
      if (status == 13) return '竞价截止';
      if (status == 3) return '已成交';
      if (status == -1) return '已流拍';
      if (backOutStatus == 1) return '已撤拍';
      return '未开始';
    },
    getStatusClass(status, backOutStatus) {
      if (status == 10) return 'status-registering';
      if (status == 0) return 'status-ended';
      if (status == 11) return 'status-auctioning';
      if (status == 12) return 'status-bidding';
      if (status == 2) return 'status-paused';
      if (status == 13) return 'status-ended-bidding';
      if (status == 3) return 'status-completed';
      if (backOutStatus == 1) return 'status-withdrawn';
      if (status == -1) return 'status-failed';
      return 'status-ended';
    },
    getDict(){
      getBizDictByCode('bulletin_type').then(res=>{
        this.bulletinTypeDict = res.data.data;
        console.log("this.bulletinTypeDict",this.bulletinTypeDict);
      });
      let treeData = [];
      getLazyTree(this.topCode).then(res => {
        treeData = res.data.data.map(item => {
          return {
            ...item,
            leaf: !item.hasChildren
          }
        })
        this.regionDict = treeData;
         if (this.regionDict.length <= 6) {
          this.firstRegions = this.regionDict;
          this.lastRegions = [];
        } else {
          this.firstRegions = this.regionDict.slice(0, this.regionDict.length - 6);
          this.lastRegions = this.regionDict.slice(this.regionDict.length - 6);
        }
      });
    },
    handleSizeChange(val){
      this.page.pageSize = val;
      this.onLoad(this.page);
    },
    handleCurrentChange(val){
      this.page.currentPage = val;
      this.onLoad(this.page);
    },
    onLoad(page){
      this.meetingLoading = true;
      cmsLotList(page.currentPage, page.pageSize, Object.assign({},this.searchParam)).then(res => {
        const data = res.data.data;
        this.page.total = data.total;
        this.bulletinData = data.records;        
        for(let i=0;i<this.bulletinData.length;i++){
          this.bulletinTypeDict.forEach(b=>{if(b.dictKey==this.bulletinData[i].type) this.bulletinData[i].typeName=b.dictValue})
        }
        this.meetingLoading = false;
        // 启动倒计时
        this.startCountdowns();
      });
    }
  },
  beforeDestroy() {
    // 组件销毁前清理所有定时器
    this.clearAllTimers();
  },
}
</script>

<style scoped>
.bulletin-table-container {
  margin-top: 20px;
  padding: 0 50px;
  background: #fff;
}

.bulletin-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: #fff;
  border-radius: 4px;
  overflow: hidden;
  table-layout: fixed;
  
  border-left: 1px solid #e8e8e8 !important;
  border-right: 1px solid #e8e8e8 !important;
}

.bulletin-table thead {
  background: #f5f7fa;
}

.bulletin-table th {
  padding: 18px 15px;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  color: #333;
  border: 1px solid #e8e8e8;
}

.bulletin-table td {
  padding: 10px 15px;
  font-size: 14px;
  color: #666;
  border: 1px solid #e8e8e8;
  text-align: center;
}

.bulletin-table-row {
  cursor: pointer;
  transition: all 0.3s ease;
}

.bulletin-table-row:hover {
  background-color: #f9f9f9;
}

.col-name {
  width: 42%;

  text-align: left !important;
}

.name-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  display: block;
  text-align: left;
}

.col-time {
  width: 18%;
}

.time-countdown {
  /* color: #d6363b; */
  font-weight: 500;
}

.time-ended {
  /* color: #999; */
}

.col-base-price,
.col-current-price {
  width: 18%;
}

.price-value {
  font-size: 14px;
  /* color: #333; */
}

.price-value.highlight {
  /* color: #d6363b; */
  /* font-weight: 600; */
}

.col-status {
  width: 11%;
  
  font-weight: 600;
}

.status-tag {
  display: inline-block;
  padding: 6px 16px;
  border-radius: 14px;
  font-size: 14px;
  font-weight: 500;
}

.status-registering {
  background: #ffffff;
  color: #1890ff;
}

.status-auctioning {
  background: #ffffff;
  color: #fa8c16;
}

.status-bidding {
  background: #ffffff;
  color: #ff4d4f;
}

.status-paused {
  background: #ffffff;
  color: #8c8c8c;
}

.status-ended-bidding {
  background: #ffffff;
  color: #8c8c8c;
}

.status-completed {
  background: #ffffff;
  color: #52c41a;
}

.status-withdrawn,
.status-failed {
  background: #ffffff;
  color: #8c8c8c;
}

.status-ended {
  background: #ffffff;
  color: #8c8c8c;
}

.bulletin-page-class{
  padding-bottom: 18px;
  height: 50px;
  background-color: rgb(255,255,255);
}

.el-page-class{
  margin-right: 45px;
  float: right;
  padding-top: 10px;
  height: 50px;
  line-height: 50px;
}
</style>

<style>
  .search-title-button:hover{
    cursor: pointer;
    box-shadow: 0px 4px 10px  rgba(0, 0, 0, 0.35);
  }
  .search-title-button{
    display: inline-block;
    margin-top: 1.5px;
    margin-left: 10px;
    width: 60px;
    height: 30px;
    border-radius: 4px;
    background: rgba(0, 102, 166, 1);
    /** 文本1 */
    font-size: 14px;
    font-weight: 400;
    line-height: 30px;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    vertical-align: top;
  }
  .bulletin-search-input-span{
    display: inline-block;
    margin-left: 60px !important;
  }
  .search-title-input{
    width: 250px;
    height: 30px;
    opacity: 1;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(214, 214, 214, 1);
  }
  .un-selected{
    color: rgba(0, 0, 0, 1);
  }
  .un-selected:hover{
    color: rgba(49, 94, 251, 1);
    cursor: pointer;
    text-decoration:underline;
  }
  .selected{
    color: rgba(0, 102, 166, 1);
  }
  .bulletin-search-left-region-div{
    display: inline-block;
    vertical-align: top;
  }
  .bulletin-search-region-div{
    display: inline-block;
    width: 1000px;
  }
  .bulletin-serach-type-item{
    display: inline-block;
    margin-right: 40px;
    /* width: 100px; */
    height: 19px;
    opacity: 1;
    /** 文本1 */
    font-size: 13px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 20px;
  }
  .bulletin-serach-region-item{
    padding-top: 5px;
    margin-bottom: 10px;
    width: 130px;
    margin-left: 20px;
    display: inline-block;
    height: 19px;
    opacity: 1;
    /** 文本1 */
    font-size: 13px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 18.82px;
  }
  .bulletin-search-item-all{
    width: 80px;
    margin-left: 20px;
    display: inline-block;

    height: 19px;
    /** 文本1 */
    font-size: 13px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 18.82px;
  }
  .bulletin-search-bottom-un-border{
    padding-bottom: 12px;
    padding-top: 12px;
  }
  .bulletin-search-bottom-border{
    border-bottom: 1px solid rgba(233, 237, 242, 1);
    padding-top: 12px;
  }
  .bulletin-search-row-div{
    display: table;
    margin-left: 50px;
    width: 1200px;
    height: 0px;
    opacity: 1;
    margin-top: 5px;
  }
  .bulletin-search-label-span{
    display: inline-block;
    width: 100px;
    height: 30px;
    opacity: 1;
    /** 文本1 */
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0px;
    line-height: 30px;
    color: rgba(51, 51, 51, 1);
    text-align: right;
  }
  .bulletin-search-div{
    width: 1300px;
    min-height: 336px;
    opacity: 1;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 4px  rgba(0, 0, 0, 0.25);
  }
</style>